const cleanAsessment = (assessment) => {
  const {
    checkedIds,
    class: klass,
    template,
    name,
    sittingDate,
    dueDate,
    notes,
    round,
    rounds,
    carryForward,
    type,
    reviewers,
    participantRoles
  } = assessment

  const filteredClasses = klass?.selectedClasses?.filter((item) => item.id !== 'all')

  const classes = filteredClasses
    ? filteredClasses.map((item) => {
        return { _id: item.id, code: item.label, reviewers: item?.reviewers || [] }
      })
    : klass?.filteredClasses

  const payload = {
    classes,
    studentsIds: checkedIds,
    notes,
    round,
    rounds: rounds || [],
    carryForward: carryForward ?? true,
    template,
    name,
    type,
    reviewers,
    participantRoles: participantRoles || ['Student'],
    sittingDate,
    dueDate
  }

  return payload
}

export default cleanAsessment
